function toSRIFormatString() {
    var dia = String(this.getDate()).padStart(2, '0');
    var mes = String(this.getMonth() + 1).padStart(2, '0');
    var ano = this.getFullYear();
    return `${dia}/${mes}/${ano}`;
}

module.exports = toSRIFormatString;
